@if (templateOptions) {
  <rl-form-table-row>
    <ng-template rlFormTableLabel>Templates</ng-template>
    <ng-template rlFormTableControl>
      <rl-dropdown-menu [(ngModel)]="selectedTemplates" [options]="templateOptions" [displayAsCheckbox]="true"
        (onValueChange)="updateTemplates()">
      </rl-dropdown-menu>
    </ng-template>
  </rl-form-table-row>
}